import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCXrnp64DCmFXK0rAl-dFtARoJTQHc7XAQ',
  authDomain: 'gameino-f19c5.firebaseapp.com',
  projectId: 'gameino-f19c5',
  storageBucket: 'gameino-f19c5.appspot.com',
  messagingSenderId: '114693674231',
  appId: '1:114693674231:web:9b23e3d5ea18d97c062ff2',
  measurementId: 'G-YTRF2SS62H',
};

export class FirebaseUtils {
  static app: any = null;

  static analytics: any = null;

  static db: any = null;

  static initialize() {
    if (!FirebaseUtils.app) {
      FirebaseUtils.app = initializeApp(firebaseConfig);
    }
    if (!FirebaseUtils.analytics) {
      FirebaseUtils.analytics = getAnalytics(FirebaseUtils.app);
    }

    if (!FirebaseUtils.db) {
      FirebaseUtils.db = getFirestore(FirebaseUtils.app);
    }
  }
}
